// IELTS Mock 5 — Academic Speaking
// Same shape as IELTS_DATA_SPEAKING in ../IeltsSpeaking.js.
const IELTS_MOCK5_SPEAKING = {
  title: "Academic Speaking Practice Test 5",
  parts: [
    {
      id: "part1",
      title: "Part 1: Introduction & Interview (4-5 min)",
      questions: [
        "Let's talk about your hometown. Where is your hometown, and what is it known for?",
        "Has your hometown changed much since you were a child?",
        "Let's talk about reading. Do you read more books now than when you were younger?",
        "Do you prefer reading on paper or on a screen? Why?",
        "What kind of books would you recommend to a friend?"
      ]
    },
    {
      id: "part2",
      title: "Part 2: Long Turn (Cue Card) (3-4 min)",
      prompt: "Describe a time when you had to make a difficult decision. You should say: What the decision was, When you had to make it, What options you considered, and explain how you felt about the decision afterwards.",
      preparationTime: 60,
      speakingTime: 120
    },
    {
      id: "part3",
      title: "Part 3: Discussion (4-5 min)",
      questions: [
        "Why do some people find it hard to make decisions?",
        "Should young people make important decisions, such as choosing a career, on their own, or with help from their parents?",
        "Do you think technology helps people make better decisions, or does it make decisions harder?",
        "Are decisions made by groups usually better than decisions made by individuals? Why?"
      ]
    }
  ]
};

export default IELTS_MOCK5_SPEAKING;
